// assets
import { IconDashboard } from '@tabler/icons-react';

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const userRole = localStorage.getItem('userRole');
const IsEmployee= userRole === 'EMPLOYEE';
const IsDev = userRole === 'DEV';

export const dashboard = {
  id: 'dashboard',
  title: IsDev ? 'Managment Dashboard ' : 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: IsEmployee ? '/mydashboard' : '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    }
  ]
};

export const myDashboard = {
  id: 'dashboard',
  title: IsDev ? 'Employee Dashboard ' : 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'My Dashboard',
      type: 'item',
      url: '/mydashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    }
  ]
};

let defaultOther;

if (userRole === 'EMPLOYEE') {
  defaultOther = myDashboard;
} else if (['MANAGER', 'HR', 'DIRECTOR'].includes(userRole)) {
  defaultOther = dashboard;
} else {
  // For unknown roles, return empty group
  defaultOther = { id: 'other', title: 'Other', type: 'group', children: [] };
}

export default defaultOther;
